/* eslint-disable */

export enum CashtagStatus {
  /**
   * AVAILABLE - The cashtag is available (or was available and is now yours, depending on the API returning
   * this CashtagStatus).
   */
  AVAILABLE = "AVAILABLE",
  /**
   * INVALID_CASHTAG - The cashtag supplied was not valid (either its length was too short or too long, or it
   * contained an invalid character). A well behaving app should never get this status.
   */
  INVALID_CASHTAG = "INVALID_CASHTAG",
  /** UNAVAILABLE - The cashtag is not available (either it is already in use, or it is not allowed to be used). */
  UNAVAILABLE = "UNAVAILABLE",
}
